import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { useActions } from '../../../hooks/useActions';
import { ExtendProductSubscriptionPageParamsType } from '../../../models/types/RoutePath';
import { clearCurrentOrganization } from '../../../store/redux-slices/organizations';
import { organizationNameSelector } from '../../../store/redux-slices/organizations/selectors';
import { clearSubscriptionExtensionSummary } from '../../../store/redux-slices/subscriptions/common';
import { clearSRSubscriptionOverview } from '../../../store/redux-slices/subscriptions/securityResponse';
import { loadOrganization } from '../../../store/saga-slices/organizations';
import { loadSRSubscriptionOverview } from '../../../store/saga-slices/subscriptions/securityResponse';
import { ILoadSRSubscriptionOverviewPayload } from '../../../store/saga-slices/subscriptions/securityResponse/models';

export const useExtendSRSubscriptionPage = () => {
  const { organizationId, subscriptionId } =
    useParams<ExtendProductSubscriptionPageParamsType>();

  const organizationName = useSelector(organizationNameSelector);

  const LoadOrganization = useActions(loadOrganization);
  const LoadSubscriptionOverview = useActions(loadSRSubscriptionOverview);
  const ClearCurrentOrganization = useActions(clearCurrentOrganization);
  const ClearCurrentSubscription = useActions(clearSRSubscriptionOverview);
  const ClearSubscriptionExtensionSummary = useActions(
    clearSubscriptionExtensionSummary,
  );

  useEffect(() => {
    LoadOrganization(organizationId);
    const loadSubscriptionOverviewPayload: ILoadSRSubscriptionOverviewPayload =
      {
        organizationId,
        subscriptionId,
      };
    LoadSubscriptionOverview(loadSubscriptionOverviewPayload);
  }, [
    LoadOrganization,
    LoadSubscriptionOverview,
    organizationId,
    subscriptionId,
  ]);

  useEffect(
    () => () => {
      ClearCurrentOrganization();
      ClearCurrentSubscription();
      ClearSubscriptionExtensionSummary();
    },
    [
      ClearCurrentOrganization,
      ClearCurrentSubscription,
      ClearSubscriptionExtensionSummary,
    ],
  );

  return { organizationName, organizationId, subscriptionId };
};
